<template>
  <fieldset class="radio-inline">
    <div v-for="(item, index) in options" :key="index">
      <RadioButton
        :value="valueProp === null ? item : item[valueProp]"
        :name="name"
        :label="item[labelProp]"
        :id="name + '-' + (index + 1)"
        :index="index"
        :model-value="modelValue"
        :data-test="dataTest"
        @update:model-value="
          $emit('update:model-value', valueProp === null ? item : item[valueProp])
        "
      />
    </div>
  </fieldset>
</template>

<script>
import RadioButton from './RadioButton.vue';

export default {
  name: 'RadioGroupInline',
  components: {
    RadioButton
  },
  props: {
    labelProp: {
      type: String,
      default() {
        return 'Label';
      }
    },
    modelValue: [Boolean, Number, Object, String],
    name: String,
    options: Array,
    value: [Boolean, Number, Object, String],
    valueProp: {
      type: String,
      default() {
        return null;
      }
    },
    dataTest: String
  },
  emits: ['update:model-value', 'blur', 'change', 'input']
};
</script>
